import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()(() => ({
  subList: {
    padding: 0,
    paddingLeft: 16,
    margin: 0,
  },
}))

export default useStyles
